import {FC} from 'react'

import {Icon, Text} from '..'
import './style.scss'


type AlertProps = {
  colorBg: string,
  id:string,
  className?: string,
  style?: any,
  color?: string,
  align?: 'left' | 'center' | 'right' | ''
}

const CustomAlert:FC<AlertProps> = ({id, className = '', children, colorBg, color = 'info', align = 'left', style }) => {

  return (
    <div id={id} className={`p-10 px-20 mt-10 d-flex align-items-center ${align ? 'text-' + align : ''} ${className}`} style={{ borderRadius: 4, background: colorBg,  ...style}}>
      <Icon name={'alert-info'} className="mr-10"  />
      <Text size="13" lineHeight="20" weight={'400'} style={{color : color}}> {children}</Text>

        <button type="button" className="alertClose" onClick={()=>closedAlert(id)}><span
            aria-hidden="true">&times;</span></button>
    </div>
  )
}
const closedAlert = (alert_id : string) => {
    const $alert: any = document.getElementById(alert_id)
    $alert.classList.remove('d-flex')
    $alert.classList.add('d-none')
}

const close = (alert_id : string) => {
    closedAlert(alert_id)
}

export { CustomAlert, close }